var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnboardSettingsFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99999 4.375C6.99999 5.50258 6.08591 6.41666 4.95832 6.41666C3.83074 6.41666 2.91666 5.50258 2.91666 4.375C2.91666 3.24741 3.83074 2.33333 4.95832 2.33333C6.08591 2.33333 6.99999 3.24741 6.99999 4.375Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 6.41666C9.00258 6.41666 9.91667 5.50258 9.91667 4.375C9.91667 3.24741 9.00258 2.33333 7.875 2.33333",
    stroke: "black",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66668 11.6667H2.24999C1.65168 11.6667 1.16666 11.219 1.16666 10.6667C1.16666 9.28597 2.37922 8.16667 3.87499 8.16667H6.04163C6.65133 8.16667 7.21401 8.35264 7.66668 8.66647",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0833 8.16667V11.6667M12.8333 9.91667H9.33334",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardSettingsFilled);
export default __webpack_public_path__ + "static/media/onboardSettingsFilled.53a7148513f21d0e66d5ba40a2d70a79.svg";
export { ForwardRef as ReactComponent };